const prefix = 'user-groups';

const SET_USER_GROUP = `${prefix}/SET_USER_GROUP`;

const SET_LOADING = `${prefix}/SET_LOADING`;

const RESET = `${prefix}/RESET`;

export { SET_USER_GROUP, RESET, SET_LOADING };
